// 店群相关接口
import { COU_httpPost, COU_httpGet } from "@/utils/http";

//获取该快手信息所对应的所有的店群
async function GetMallGroupList() {
  var url = `mallGroup/getGroupListByAuth`;
  var r = await COU_httpGet({ url });
  var msg = ``;
  var success = false;
  var mallGroupList = [];
  try {
    msg = r.msg;
    success = r.success;
    mallGroupList = r.result.Datas;
  } catch (error) {
    console.log(error);
  }
  return { msg, success, mallGroupList: mallGroupList || [] };
}

// 获取店铺列表通过店群的id
async function GetMallListByGroupId(page = 1, size = 100, GroupId) {
  var url = `/mallGroup/getGroupAuthListByGroupId?page=${page}&size=${size}&groupId=${GroupId}`;
  var r = await COU_httpGet({ url });
  var mallList = [];
  var success = false;
  var msg = ``;
  var total = 0;
  try {
    msg = r.msg;
    success = r.success;
    total = r.result.TotalNum;
    mallList = r.result.Datas;
  } catch (error) {
    console.log(error);
  }

  return { mallList: mallList || [], success, msg, total };
}

// 创建店群
async function CreateGroup(name) {
  var url = `/mallGroup/addGroup`;
  var data = { name };
  var r = await COU_httpPost({ url, data });
  var success = false;
  var msg = ``;
  try {
    success = r.success;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }

  return { msg, success };
}

// 获取邀请码
async function GetInviteCode(groupId) {
  var url = `/mallGroup/refreshInviteCode`;
  var data = {
    groupId,
  };
  var r = await COU_httpPost({ url, data });
  var InviteCode = ``;
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
    InviteCode = r.result.InviteCode;
  } catch (error) {
    console.log(error);
  }
  return { msg, success, InviteCode };
}

// 加入店群
async function AddGroup(inviteCode) {
  var url = `/mallGroup/joinGroup`;
  var data = {
    inviteCode,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, success };
}

// 解散店群
async function DelGroup(groupId) {
  var url = `/mallGroup/dissolutionGroup`;
  var data = {
    groupId,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, success };
}

// 修改店群中店铺的配置(邀请码/ 是否查看其他店铺订单的权限)
async function UpdataMallGroupConfig(relationId, val, modifyType) {
  var url = `/mallGroup/changeRelation`;
  var data = {
    mallGroupRelationId: relationId,
    updateFields: modifyType,
  };
  data[modifyType] = val;
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, success };
}

export default {
  GetMallGroupList,
  CreateGroup,
  GetMallListByGroupId,
  GetInviteCode,
  AddGroup,
  DelGroup,
  UpdataMallGroupConfig,
};
